module.exports = __webpack_public_path__ + "img/DAF.60e4cd58.svg";